const Strip = (value, isStrict = false) => {
  const STRICT_STRIP_REGEX = /[.-]/g;
  const LOOSE_STRIP_REGEX = /[^\d]/g;
  const ALPHANUMERIC_STRIP_REGEX = /[^A-Za-z0-9]/g;

  let regex = LOOSE_STRIP_REGEX;
  if (isStrict === true) {
    regex = STRICT_STRIP_REGEX;
  } else if (isStrict === 'alphanumeric') {
    regex = ALPHANUMERIC_STRIP_REGEX;
  }

  return (value || '').toString().replace(regex, '');
};
export default Strip;
